import React from "react";
import PropTypes from "prop-types";
import PdfIcon from "../../Assets/Images/pdf-icon-edited.png";
import TxtIcon from "../../Assets/Images/txt-icon-edited.png";
import ImgIcon from "../../Assets/Images/img-icon-edited.png";
import PngIcon from "../../Assets/Images/png-icon-edited.png";
import folderIcon from "../../Assets/Images/folder-icon.png";
import filelogo from "../../Assets/Images/basil_file-upload-outline.png";

const getFileExtension = (fileName) => {
  if (!fileName || typeof fileName !== "string") return "";
  const lastDotIndex = fileName.lastIndexOf(".");
  if (lastDotIndex === -1) return "";
  return fileName.slice(lastDotIndex + 1).toLowerCase();
};

const getFileIcon = (fileName, extension, theme) => {
  const iconMappings = {
    pdf: PdfIcon,
    txt: TxtIcon,
    png: PngIcon,
    jpg: ImgIcon,
    jpeg: ImgIcon,
    "": folderIcon,
  };
  return iconMappings[extension] || filelogo;
};

const FileIcon = ({ fileName = "", theme }) => {
  const safeFileName = fileName || "";
  const extension = getFileExtension(safeFileName);
  const icon = getFileIcon(safeFileName, extension, theme);

  return (
    <img
      src={icon}
      alt="file icon"
      className="file-img"
      style={{ width: "25px", height: "25px" }}
    />
  );
};

FileIcon.propTypes = {
  fileName: PropTypes.string,
  theme: PropTypes.string,
};

export default FileIcon;
